import { PropsWithChildren } from 'react';

import { cn } from '../lib';

export const IconWrapper = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <div
      className={cn(
        'flex h-10 w-10 items-center justify-center rounded-full bg-base-100 p-2',
        className,
      )}
    >
      {children}
    </div>
  );
};
